'use strict';

var tslib_es6 = require('./_chunks/tslib.es6-DSduP8Mp.js');
var react = require('react');
var validationState = require('./validationState.js');
require('class-validator');
require('@templafy/translation');
require('./keys.js');
require('./fieldMetadata.js');
require('./validationPointers.js');

function useFormValidation(validationClass, options = {}, deps = []) {
    const [validationState$1, dispatch] = react.useReducer(validationState.createReducer(validationClass, options.validation), validationState.initializeValidationState(validationClass, options.values || {}, options.validation, options.loadValues != null));
    const safeDispatch = react.useRef(dispatch);
    react.useEffect(() => {
        safeDispatch.current = dispatch;
        return () => {
            safeDispatch.current = null;
        };
    }, [dispatch]);
    const loadValues = react.useCallback(() => tslib_es6.__awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        if (options.loadValues != null) {
            try {
                (_a = safeDispatch.current) === null || _a === void 0 ? void 0 : _a.call(safeDispatch, {
                    type: 'loadValues',
                });
                const values = yield options.loadValues();
                (_b = safeDispatch.current) === null || _b === void 0 ? void 0 : _b.call(safeDispatch, {
                    type: 'loadedValues',
                    values: values || {},
                });
            }
            catch (error) {
                (_c = safeDispatch.current) === null || _c === void 0 ? void 0 : _c.call(safeDispatch, {
                    type: 'loadValuesFailed',
                    error: error instanceof Error ? error.message : 'Failed loading values',
                });
            }
        }
        else if (options.values != null) {
            (_d = safeDispatch.current) === null || _d === void 0 ? void 0 : _d.call(safeDispatch, {
                type: 'loadValues',
            });
            (_e = safeDispatch.current) === null || _e === void 0 ? void 0 : _e.call(safeDispatch, {
                type: 'loadedValues',
                values: options.values,
            });
        }
    }), [options]);
    react.useEffect(() => {
        void loadValues();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    const setValue = (name, value) => {
        dispatch({
            type: 'setValue',
            fieldName: name,
            value,
        });
    };
    const submit = () => tslib_es6.__awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const result = options.onSubmit == null || validationState$1.hasErrors
            ? undefined
            : options.onSubmit(validationState$1.values);
        if (result != null) {
            const serverValidationPointers = yield result;
            (_a = safeDispatch.current) === null || _a === void 0 ? void 0 : _a.call(safeDispatch, {
                type: 'submit',
                serverValidationPointers,
            });
        }
        else {
            (_b = safeDispatch.current) === null || _b === void 0 ? void 0 : _b.call(safeDispatch, {
                type: 'submit',
            });
        }
    });
    const publicValidationState = {
        values: validationState$1.values,
        disableSubmit: validationState$1.disableSubmit,
        fields: validationState$1.fields,
        hasErrors: validationState$1.hasErrors,
        loadingValues: validationState$1.loadingValues,
        loadedValues: validationState$1.loadedValues,
        loadValuesFailed: validationState$1.loadValuesFailed,
        loadValuesError: validationState$1.loadValuesError,
    };
    const contract = validationState$1.hasErrors === true
        ? undefined
        : validationState$1.values;
    return [publicValidationState, setValue, submit, contract];
}

exports.useFormValidation = useFormValidation;
//# sourceMappingURL=useFormValidation.js.map
